const FEATURES = [
  {
    icon: 'ri-search-eye-line',
    title: 'ハウスメーカー中立比較',
    desc: '特定のハウスメーカーに縛られない中立的な立場で、最適な建築パートナーを選定します。',
  },
  {
    icon: 'ri-line-chart-line',
    title: '収益シミュレーション',
    desc: '賃貸収入の試算から返済計画まで、収益性と安心を両立する資金計画を提案します。',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: '土地・立地調査',
    desc: '周辺の賃貸需要や将来性を徹底的に調査。失敗しない立地選定をサポートします。',
  },
  {
    icon: 'ri-draft-line',
    title: '建築計画立案',
    desc: '自宅部分と賃貸部分のバランスを考慮した、最適な間取りと設計計画を立案します。',
  },
  {
    icon: 'ri-team-line',
    title: '入居者募集戦略',
    desc: '建築後の空室リスクを最小化するための、ターゲット設定から募集戦略まで支援します。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '建築後の運用サポート',
    desc: '物件完成後も長期的なパートナーとして、運用・管理に関するご相談に応じます。',
  },
];

const scrollToSection = (id: string) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function TatesapoSection() {
  return (
    <section id="tatesapo" className="py-24 bg-[#f5f8ff]">
      <div className="max-w-6xl mx-auto px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <p className="text-[#1e3a70] text-sm font-medium tracking-widest uppercase mb-3">建てサポ事業</p>
            <h2 className="text-3xl font-bold text-stone-800 mb-6 leading-tight">
              賃貸併用住宅の建築を、<br />
              プロが中立的にサポート
            </h2>
            <p className="text-stone-500 leading-relaxed mb-6">
              賃貸併用住宅は「世界で一番難しい設計」とも言われます。自宅と賃貸経営を両立させるためには、建築の専門知識だけでなく、不動産・金融・マーケティングの幅広い知見が必要です。
            </p>
            <p className="text-stone-500 leading-relaxed mb-8">
              建てサポは、特定のハウスメーカーに縛られない<strong className="text-stone-700">中立的なコンサルタント</strong>として、お客様の最善の選択をサポートします。建築計画の立案から入居者募集まで、一貫したサポートを提供します。
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href="https://tatesapo.jp/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center gap-2 border border-[#1e3a70] text-[#1e3a70] hover:bg-[#eef3fb] font-medium px-7 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap"
              >
                公式サイトを見る
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-external-link-line text-sm"></i>
                </div>
              </a>
            </div>
          </div>
          <div className="relative rounded-2xl overflow-hidden" style={{ height: '420px' }}>
            <img
              src="https://public.readdy.ai/ai/img_res/0f06d830127e4a8925f6e2d77b36038f.jpg"
              alt="賃貸併用住宅"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-xl p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#eef3fb] rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-[#1e3a70] text-xl"></i>
                </div>
                <div>
                  <p className="text-stone-800 font-semibold text-sm">建築コンサルティング実績多数</p>
                  <p className="text-stone-400 text-xs">お客様の大切な夢の実現をサポート</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-xl font-bold text-stone-800 mb-8 text-center">サービス内容</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {FEATURES.map((f) => (
              <div key={f.title} className="bg-[#f5f8ff] rounded-xl p-6 hover:bg-[#eef3fb] transition-colors">
                <div className="w-11 h-11 bg-[#dce6f5] rounded-full flex items-center justify-center mb-4">
                  <i className={`${f.icon} text-[#1e3a70] text-xl`}></i>
                </div>
                <h4 className="font-semibold text-stone-800 mb-2 text-sm">{f.title}</h4>
                <p className="text-stone-500 text-xs leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
